import { render, staticRenderFns } from "./ChecklistForm.vue?vue&type=template&id=11567b27&"
import script from "./ChecklistForm.vue?vue&type=script&lang=js&"
export * from "./ChecklistForm.vue?vue&type=script&lang=js&"
import style0 from "./ChecklistForm.vue?vue&type=style&index=0&id=11567b27&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports